import Api from './Api';

const abortKey = 'FiBuMitgliedsbeitraegeApi'
const endpoint = '/fibu/mitgliedsbeitraege/';

export default {
    abort() {
        Api.abort(abortKey);
    },
    getMitgliedsbeitraegeVerwaltung() {
        return Api.fetchData(endpoint + 'verwalten');
    },
    get(id) {
        return Api.fetchData(endpoint + 'verwalten/' + id);
    },
    getMitgliedsbeitraegeToBook(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + 'erstellen',
            usedParams,
            true,
            false,
            abortKey
        );
    },
    printSelectedMitgliedsbeitraege(params) {
        var usedParams = {};
        Api.handleDefaultParams(params, usedParams);
        return Api.fetchData(
            endpoint + 'drucken',
            usedParams,
            true,
            false,
            abortKey
        )
    },
    getAllYearsRelatedToMitgliederbeitraege() {
        return Api.fetchData(endpoint + 'years');
    },
    post(id, data) {
        return Api.postData(endpoint + 'verwalten/' + id, data);
    },
    postMitgliedsBeitraege(data) {
        return Api.postData(endpoint + 'erstellen', data);
    },
    put(id, data) {
        return Api.putData(endpoint + 'verwalten/' + id, data);
    },
    delete(id) {
        return Api.deleteData(endpoint + 'verwalten/' +id);
    },
};